interface Props {}

import ActionsMenu from "@/components/DesignSystemBuilder/components/ActionsMenu";
import useDesignSystemStore, {
  GenerationStatus,
} from "@/store/zustand/aiDesignSystemBuilder";
import GenerationView from "@/components/DesignSystemBuilder/components/GenerationView";
import GenerationEmptyState from "@/components/DesignSystemBuilder/components/GenerationEmptyState";
import GenerationActions from "@/components/DesignSystemBuilder/components/GenerationActions";
import React from "react";
import PromptEditor from "./DSPromptEditor";
import { useFeatureFlagEnabled } from "posthog-js/react";

const Panel: React.FC<Props> = ({}) => {
  const status = useDesignSystemStore((state) => state.generation.status);
  const showDesignSystem = useFeatureFlagEnabled("custom_design_system");
  return (
    <div className="w-full overflow-y-scroll">
      <div className="flex flex-col text-xs gap-4">
        <div className="flex flex-row justify-between items-center sticky top-0 py-4 px-6 bg-secondary-0 border-b border-secondary-300">
          <div className="font-bold text-sm bg-clip-text text-transparent from-primary-800 bg-gradient-to-r to-primary-700 sticky top-0">
            Design System Builder
          </div>
          <ActionsMenu />
        </div>
        <div className="px-6 flex flex-col gap-4">
          {status === GenerationStatus.Pending ? (
            <GenerationEmptyState />
          ) : (
            <GenerationView />
          )}
        </div>
        <div className="flex flex-row justify-between items-center px-6 py-4 sticky bottom-0 bg-secondary-0 border-t border-secondary-300">
          <GenerationActions />
        </div>
        {showDesignSystem && (
          <div className="px-4">
            <PromptEditor />
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Panel);
